/** @jsxImportSource @emotion/react */
import React, { useCallback, useEffect, useState } from "react";
import Notifications from "./screens/Notifications";
import Settings from "./screens/Settings";
import Profile from "./screens/Profile";
import Sublime from "./screens/Sublime";
import Root from "./screens/Root";
import axios from "axios";
import "./fonts/SF-Pro-Italic.ttf";
import "./fonts/SF-Pro-Rounded-Black.otf";
import "./fonts/SF-Pro-Rounded-Bold.otf";
import "./fonts/SF-Pro-Rounded-Heavy.otf";
import "./fonts/SF-Pro-Rounded-Light.otf";
import "./fonts/SF-Pro-Rounded-Medium.otf";
import "./fonts/SF-Pro-Rounded-Regular.otf";
import "./fonts/SF-Pro-Rounded-Semibold.otf";
import "./fonts/SF-Pro-Rounded-Thin.otf";
import "./fonts/SF-Pro-Rounded-Ultralight.otf";
import "./fonts/SF-Pro.eot";
import "./fonts/SF-Pro.otf";
import "./fonts/SF-Pro.ttf";
import "./fonts/SF-Pro.woff";
import "./fonts/SF-Pro.woff2";
import {
  createBrowserRouter,
  Navigate,
  Outlet,
  RouterProvider,
  useLocation,
  useNavigate,
} from "react-router-dom";
import "./App.css";
import SignIn from "./screens/SignIn";
import SignUp from "./screens/SignUp";
import Collections from "./screens/Collections";
import Person from "./screens/Person";
import Member from "./screens/Member";
import Content from "./screens/Content";
import TextPage from "./screens/Text";
import Note from "./screens/Note";
import Highlight from "./screens/Highlight";
import Add from "./screens/Add";
import {
  getAuth,
  isSignInWithEmailLink,
  signInWithEmailLink,
  User,
} from "firebase/auth";

let token = "";
const API = axios.create({ baseURL: "https://staging.sublime.app/api/v2" });
API.interceptors.request.use((config) => {
  return {
    ...config,
    headers: {
      Authorization: `Bearer ${token}`,
      ...config.headers,
    },
  } as unknown as typeof config;
});
API.interceptors.response.use(
  (response) => response,
  async (error) => {
    if (error.response && error.response.status === 403) {
      const {
        data: { access },
      } = await API.post("/auth/token", {
        email: "israel+admin@startupy.world",
      });
      token = access;
      const { config } = error;
      config.headers.Authorization = `Bearer ${token}`;
      return API(config);
    }

    return Promise.reject(error);
  }
);

const RequireAuth: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [user, setUser] = useState<User | null>(null);
  const [checkedIfUserIsAuthenticated, setCheckedIfUserIsAuthenticated] =
    useState(false);

  // useEffect(() => {
  //   const auth = getAuth();
  //   auth.onAuthStateChanged((user) => {
  //     if (user !== null) setUser(user);
  //     setCheckedIfUserIsAuthenticated(true);
  //   });
  // }, []);

  // const checkUser = useCallback(async () => {
  //   if (!checkedIfUserIsAuthenticated) return;
  //   const auth = getAuth();

  //   if (user === null && isSignInWithEmailLink(auth, window.location.href)) {
  //     const params = new URLSearchParams(window.location.search);
  //     const email = params.get("email");

  //     try {
  //       await signInWithEmailLink(auth, email as string, window.location.href);
  //       navigate("/");
  //     } catch (e) {
  //       navigate("/auth/sign-in");
  //     }

  //     return;
  //   }

  //   if (user !== null && location.pathname.includes("auth")) navigate("/");

  //   if (user === null && !location.pathname.includes("auth"))
  //     navigate("/auth/sign-in");
  // }, [location, navigate, user, checkedIfUserIsAuthenticated]);

  // useEffect(() => {
  //   checkUser();
  // }, [checkUser]);

  // if (user === null) return null;

  return <Outlet />;
};

const router = createBrowserRouter([
  {
    path: "/",
    element: <RequireAuth />,
    children: [
      {
        path: "/",
        element: <Root />,
        children: [
          {
            path: "",
            element: <Sublime />,
          },
          {
            path: "notifications",
            element: <Notifications />,
          },
          {
            path: "settings",
            element: <Settings />,
          },
          {
            path: "person/:personId",
            element: <Person />,
          },
          {
            path: "collection/:collectionId",
            element: <Collections />,
          },
          {
            path: "add",
            element: <Add />,
          },
          {
            path: "profile",
            element: <Profile />,
          },
          {
            path: "/:memberId",
            element: <Member />,
          },
          {
            path: "/article/:articleId",
            element: <Content />,
          },
          {
            path: "/video/:videoId",
            element: <Content />,
          },
          {
            path: "/audio/:audioId",
            element: <Content />,
          },
          {
            path: "/book/:bookId",
            element: <Content />,
          },
          {
            path: "/tweet/:tweetId",
            element: <Content />,
          },
          {
            path: "/link/:websiteId",
            element: <Content />,
          },
          {
            path: "/text/:textId",
            element: <TextPage />,
          },
          {
            path: "/note/:noteId",
            element: <Note />,
          },
          {
            path: "/highlight/:highlightId",
            element: <Highlight />,
          },
        ],
      },
    ],
  },
  {
    path: "/auth",
    element: <Outlet />,
    children: [
      {
        index: true,
        element: <Navigate to="sign-in" />,
      },
      {
        path: "sign-in",
        element: <SignIn />,
      },
      {
        path: "sign-up",
        element: <SignUp />,
      },
    ],
  },
]);

const App: React.FC = () => (
  <React.StrictMode>
    <RouterProvider router={router} />
  </React.StrictMode>
);

export default App;
